import { atom } from "recoil"

export const Display= atom({
    key:'DISPLAY',
    default:''
})